export const environment = {
  production: true,
  product: 'passoffice',
};
